var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.459.16v11.2h17.78V.16H.459Zm15.51 1.03-6.66 4.29-6.6-4.29h13.26Zm-14.48 9.14v-8.7l7.81 5.08 7.91-5.09v8.71H1.489Z",
    fill: "currentColor"
  })));
};
export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTkgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjQ1ODk4NCAwLjE1OTY2OFYxMS4zNTk2SDE4LjIzOVYwLjE1OTY2OEgwLjQ1ODk4NFpNMTUuOTY5IDEuMTg5N0w5LjMwODk2IDUuNDc5NzRMMi43MDg5OCAxLjE4OTdIMTUuOTY5Wk0xLjQ4OTAxIDEwLjMyOTZWMS42Mjk2NEw5LjI5ODk1IDYuNzA5NzJMMTcuMjA5IDEuNjE5NjNWMTAuMzI5NkgxLjQ4OTAxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";